import BoardShare from '../../view/share/BoardShare'
import BoardShareDetail from '../../view/share/BoardShareDetail'

export default [
    {
        path:'/boardShare/:id',
        component: BoardShare,
    },
    {
        path:'/boardShareDetail/:id',
        component: BoardShareDetail,
    }
]


// WEBPACK FOOTER //
// ./src/router/model/share.js